// extracted by mini-css-extract-plugin
export default {"root":"N1ReVs","trigger":"sfVlID","triggerTitle":"hZAIWX","triggerIcon":"gJmwns","nav":"urZ5g3","link":"LrXLjZ","itemSticky":"qNIg0P"};